import mixpanel from 'mixpanel-browser';

export const triggerAnalyticsEvent = (eventName, eventData = {}) => {
  const currentDomain = window.location.hostname;
  mixpanel.track(eventName, {
    ...eventData,
    current_domain: currentDomain,
  });
};
